/* eslint-disable max-len */
<template>
  <sui-modal v-model="modalOpen">
    <sui-modal-header>
      Result details
      <button v-on:click="showExtraDetails" class="ui button right floated">
        {{ extraDetails ? 'Hide' : 'Show' }} extra details
      </button>
    </sui-modal-header>
    <sui-modal-content scrolling>
      <table class="ui striped selectable table" v-if="result">
        <thead>
          <tr>
            <th>Student name</th>
            <th>
              {{ `${result.student.lastName}, ${result.student.firstName} (${result.student.initials})` }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Likes given</td>
            <td>{{ result.liked }}</td>
          </tr>
          <tr>
            <td>Likes received</td>
            <td>{{ result.likes }}</td>
          </tr>
          <tr>
            <td>Rejects given</td>
            <td>{{ result.disliked }}</td>
          </tr>
          <tr>
            <td>Rejects received</td>
            <td>{{ result.dislikes }}</td>
          </tr>
          <tr>
            <td>Social impact</td>
            <td>{{ result.socialImpact }}</td>
          </tr>
          <tr>
            <td>Social preference</td>
            <td>{{ result.socialPreference }}</td>
          </tr>
          <tr>
            <td>Classification(s)</td>
            <td>
              <span v-for="classification in result.classifications" v-bind:key="classification">
                <a v-if="classification == 'Liked'" v-on:click="showClassificationLegend($event, 'L')"
                  class="ui purple label">L
                </a>
                <a v-if="classification == 'OneLikeReceived'" v-on:click="showClassificationLegend($event, '1LR')"
                  class="ui grey label">1LR
                </a>
                <a v-if="classification == 'Unchosen'" v-on:click="showClassificationLegend($event, 'UN')"
                  class="ui grey label">UN
                </a>
                <a v-if="classification == 'Rejected'" v-on:click="showClassificationLegend($event, 'R')"
                  class="ui yellow label">R
                </a>
                <a v-if="classification == 'Neglected'" v-on:click="showClassificationLegend($event, 'N')"
                  class="ui green label">N
                </a>
                <a v-if="classification == 'Controversial'" v-on:click="showClassificationLegend($event, 'C')"
                  class="ui teal label">C
                </a>
                <a v-if="classification == 'Average'" v-on:click="showClassificationLegend($event, 'A')"
                  class="ui brown label">A
                </a>
                <a v-if="classification == 'Unclassified'" v-on:click="showClassificationLegend($event, 'UC')"
                  class="ui blue label">UC
                </a>
              </span>
            </td>
          </tr>
          <tr v-if="extraDetails">
            <td>Amount of students</td>
            <td>
              {{ testResult.amountOfStudents }}
            </td>
          </tr>
          <tr v-if="extraDetails">
            <td>Standardized likes received</td>
            <td>{{ result.zl.toFixed(2) }}</td>
          </tr>
          <tr v-if="extraDetails">
            <td>Standardized rejects received</td>
            <td>{{ result.zr.toFixed(2) }}</td>
          </tr>
        </tbody>
      </table>
      <h3>Choice details</h3>
      <table class="ui striped selectable table" v-if="result">
        <thead>
          <tr>
            <th>Last name</th>
            <th>First name</th>
            <th>Initials</th>
            <th>Choice made</th>
            <th>Choice received</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="resultChoices.length == 0">
            <td colspan="5">No choices found</td>
          </tr>
          <tr v-else v-for="choice in resultChoices" v-bind:key="choice.targetStudent.id">
            <td>{{ choice.targetStudent.lastName }}</td>
            <td>{{ choice.targetStudent.firstName }}</td>
            <td>{{ choice.targetStudent.initials }}</td>
            <td>{{ choice.choice }}</td>
            <td>{{ getChoiceReceived(choice.targetStudent.id) }}</td>
          </tr>
        </tbody>
      </table>
      <sui-button v-if="isAdmin" negative v-on:click="resetChoices"> Reset choices </sui-button>
    </sui-modal-content>
    <sui-modal-actions>
      <sui-button positive v-on:click="hideDetailsModal"> Ok </sui-button>
    </sui-modal-actions>
  </sui-modal>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'TestResultDetails',
  components: {},
  computed: {
    ...mapGetters({
      testResultDetailsOpen: 'testResultDetailsOpenNew',
      result: 'testResultDetails',
      testResult: 'testResult',
      user: 'user',
    }),
    isAdmin: {
      get() {
        return this.user && this.user.profile &&
          (this.user.profile.role === 'Administrator' || this.user.profile.role === 'TeacherAdministrator');
      },
    },
    modalOpen: {
      get() {
        return this.testResultDetailsOpen;
      },
      set(isOpen) {
        this.hideDetailsModal();
        return isOpen;
      },
    },
    resultChoices: {
      get() {
        return [
          ...this.result.choices.filter(
            (c) =>
              c.choice === 'Like' &&
              this.getChoiceReceived(c.targetStudent.id) === 'Like',
          ).sort((a, b) => a.targetStudent.lastName.localeCompare(b.targetStudent.lastName)),
          ...this.result.choices.filter(
            (c) =>
              c.choice === 'Dislike' &&
              this.getChoiceReceived(c.targetStudent.id) === 'Dislike',
          ).sort((a, b) => a.targetStudent.lastName.localeCompare(b.targetStudent.lastName)),
          ...this.result.choices.filter(
            (c) =>
              (c.choice !== 'Like' && c.choice !== 'Dislike') ||
              c.choice !==
              this.getChoiceReceived(c.targetStudent.id),
          ).sort((a, b) => a.targetStudent.lastName.localeCompare(b.targetStudent.lastName)),
        ];
      },
    },
  },
  data() {
    return {
      extraDetails: false,
    };
  },
  created() { },
  methods: {
    showExtraDetails() {
      this.extraDetails = !this.extraDetails;
    },
    getChoiceReceived(targetStudentId) {
      const targetStudents = this.testResult.students.filter(
        // eslint-disable-next-line arrow-parens
        (result) => result.student.id === targetStudentId,
      );
      const targetStudent =
        targetStudents && targetStudents.length > 0 ? targetStudents[0] : null;

      if (!targetStudent) return 'no choice';

      const choices = targetStudent.choices.filter(
        // eslint-disable-next-line arrow-parens
        (result) => result.targetStudent.id === this.result.student.id,
      );

      const choice = choices && choices.length > 0 ? choices[0] : null;
      if (!choice) return 'no choice';

      return choice.choice;
    },
    hideDetailsModal() {
      this.$store.dispatch('hideTestResultDetailsNew');
    },
    resetChoices() {
      this.$dialog
        .confirm('Please confirm to reset the choices for this student')
        .then(() => {
          this.$store.dispatch('resetTest', { testId: this.testResult.id, studentId: this.result.student.id }).then(() => {
            this.$store.dispatch('hideTestResultDetailsNew');
            // Refresh the page
            window.location.reload();
          });
        })
        .catch(() => { });

    },
    showClassificationLegend(event, category) {
      event.stopPropagation();
      this.$store.dispatch('showClassificationLegend', category);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/tests/TestResultDetails.vue